import React, { useEffect, useContext, useState } from "react";
import { logOut, firestore, storage } from '../../firebase.js';
import { UserContext } from "../../Providers/UserProvider";
import {Form, Button, InputGroup, FormControl} from "react-bootstrap";
import '../../Styles/Sass/form.sass';
import { Wizard, Steps, Step } from 'react-multistep-wizard';

function ProfileForm(){
  const [file, setFile] = useState(null);
  const [fileTwo, setFileTwo] = useState(null);

  const user = useContext(UserContext);

  const submitHandler = async (e) => {
    e.preventDefault();
    let userUploads = [];
    const storageRef = storage.ref();
    const fileRef = storageRef.child(file.name);
    const fileRefTwo = storageRef.child(fileTwo.name);
    await fileRef.put(file);
    await fileRef.put(fileTwo);
    await firestore.collection('users').doc(`${user.uid}`).get()
      .then(res => {
        if (res.data().uploads) {
          userUploads = res.data().uploads
        }
      })
      .catch(err => {
        console.log(err);
      });
    userUploads.push({
      name: file.name,
      url: await fileRef.getDownloadURL()
    });
    userUploads.push({
      name: file.name,
      url: await fileRef.getDownloadURL()
    });
    firestore.collection('users').doc(user.uid)
      .update({
        services: e.target.services.value,
        rate: e.target.rate.value,
        headline: e.target.headline.value,
        description: e.target.descService.value,
        // service: e.target.servReq.value,
        equipment: e.target.equipment.value,
        uploads: userUploads
      })
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      })
  }

  const changeHandler = (e) => {
    setFile(e.target.files[0]);
  }

  const changeHandlerTwo = (e) => {
    setFileTwo(e.target.files[0]);
  }

  const uploadHandler = async (e) => {
    e.preventDefault();
    let userUploads = [];
    const storageRef = storage.ref();
    const fileRef = storageRef.child(file.name);
    await fileRef.put(file);
    await firestore.collection('users').doc(`${user.uid}`).get()
      .then(res => {
        if (res.data().uploads) {
          userUploads = res.data().uploads
        }
      })
      .catch(err => {
        console.log(err);
      });
    userUploads.push({
      name: file.name,
      url: await fileRef.getDownloadURL()
    });
    firestore.collection('users').doc(user.uid).update({
      uploads: userUploads
    });
  }

  return(
    <>
      {
        user === null ?
          <>
          </> :
          <>
            <div className="formDiv">
              <Form onSubmit={submitHandler}  action="">
                <h3 className="center">What are you looking to do?</h3>
                <br></br>
                {['radio'].map((type) => (
                  <div className="center">
                    <div className="donate-now" key={`inline-${type}`} className="mb-3">
                      <Form.Check className="" inline label="Find a Job" name="group1" type={type} id={`inline-${type}-1`} />
                      <Form.Check className="" inline label="Hire a Cleaner" name="group1" type={type} id={`inline-${type}-2`} />
                    </div>
                  </div>
                ))}
                <Form.Group controlId="areofwork">
                  <Form.Label>Area of Work</Form.Label>
                  <Form.Control id="services" name="services" as="select">
                    <option value="home">Home</option>
                    <option value="commercial">Commercial</option>
                    <option value="resturant">Resturant</option>
                    <option value="industrial">Industrial</option>
                    <option value="project">Project</option>
                    <option value="events">Events</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group className="rateSec">
                <h3>What rate do you charge?</h3>
                <p>Must be a minimum of $16 an hour</p>
                  <InputGroup className="mb-3" block>
                  <InputGroup.Prepend>
                    <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                  </InputGroup.Prepend>
                    <FormControl id="rate" name="rate" placeholder="Rate" aria-label="Recipient's username" aria-describedby="basic-addon2"/>
                    <InputGroup.Append>
                      <InputGroup.Text id="basic-addon2">Per Hour</InputGroup.Text>
                    </InputGroup.Append>
                  </InputGroup>
                </Form.Group>
                <Form.Group controlId="headline">
                  <Form.Label>Headline</Form.Label>
                  <Form.Control name='headline' id="headline" as="textarea" rows={1} />
                </Form.Group>
                <Form.Group controlId="descService">
                  <Form.Label>Description of Services</Form.Label>
                  <Form.Control id="descService" name="descService" as="textarea" rows={10} />
                </Form.Group>
                <Form.Group controlId="servReq">
                  <Form.Label>Service Requirements</Form.Label>
                  <Form.Control id="servReq" name="servReq"  as="textarea" rows={10} />
                </Form.Group>
                <br></br>
                <h3 className="center">Do you provide cleaning supplies and equipment?</h3>
                {['radio'].map((type)  => (
                  <div className="center">
                    <div className="center" key={`inline-${type}`} className="mb-3">
                      <Form.Check inline label="I provide cleaning supplies" name="supplies" type={type} id={`inline-${type}-1`} />
                      <Form.Check inline label="I do not provide cleaning supplies" name="supplies" type={type} id={`inline-${type}-2`} />
                    </div>
                  </div>
                ))}
                {['radio'].map((type)  => (
                  <div className="center">
                    <div name="equipment"className="center" key={`inline-${type}`} className="mb-3">
                      <Form.Check inline label="I provide cleaning equipment"id="equipment" type={type} id={`inline-${type}-1`} />
                      <Form.Check inline label="I do not provide cleaning equipment" name="equipment" type={type} id={`inline-${type}-2`} />
                    </div>
                  </div>
                ))}
                <br></br>
                <h3 className="center">What availability do you require?</h3>
                {['checkbox'].map((type)  => (
                  <div className="center">
                    <div className="center" key={`inline-${type}`} className="mb-3">
                      <Form.Check inline label="Mornings" name="group1" type={type} id={`inline-${type}-1`} />
                      <Form.Check inline label="Evenings" name="group1" type={type} id={`inline-${type}-2`} />
                    </div>
                    <div className="center" key={`inline-${type}`} className="mb-3">
                      <Form.Check inline label="Days" name="group1" type={type} id={`inline-${type}-1`} />
                      <Form.Check inline label="Nights" name="group1" type={type} id={`inline-${type}-2`} />
                    </div>
                    <div className="center" key={`inline-${type}`} className="mb-3">
                      <Form.Check inline label="Afternoons" name="group1" type={type} id={`inline-${type}-1`} />
                      <Form.Check inline label="Weekends" name="group1" type={type} id={`inline-${type}-2`} />
                    </div>
                  </div>
                ))}
                <br></br>
                <Form.Group>
                  <Form.File id="whmisfile" name='policecheck' onChange={changeHandler} label="Upload your Police Check" />
                </Form.Group>
                <Form.Group>
                  <Form.File id="policecheckfile" name='whimis' onChange={changeHandlerTwo} label="Upload you WHMIS Certification" />
                </Form.Group>
                <div className="divSubmit">
                  <button className="submitButton" type='submit' >Submit</button>
                  <br></br>
                </div>
              </Form>
            </div>
          </>
      }
    </>
  );
}

export default ProfileForm;